Ext.define('SA.data.BusinessSearchTableView', {
    alias: 'view.businessSearchTable',
    extend: 'SA.data.ReportView',

    mixins: {
        locations: 'SA.data.mixin.OneLocation'
    },

    statics: {
        columns: [
            {attribute: 'point_id', name: 'DUNS Number'},
            {attribute: 'legal_name', name: 'Company Name', initial: true},
            {attribute: 'dba1', name: 'Business Name', initial: true},
            {attribute: 'dba2', name: 'Business Name 2'},
            {attribute: 'dba3', name: 'Business Name 3'},
            {attribute: 'dba4', name: 'Business Name 4'},
            {attribute: 'dba5', name: 'Business Name 5'},

            {attribute: 'street_address', name: 'Street Address', initial: true},
            {attribute: 'city', name: 'City', initial: true},
            {attribute: 'state', name: 'State'},
            {attribute: 'state_abbrv', name: 'State Abbreviation', initial: true},
            {attribute: 'zip', name: 'Zip Code', initial: true},

            {attribute: 'mailing_address', name: 'Mailing Street Address'},
            {attribute: 'mailing_city_name', name: 'Mailing City'},
            {attribute: 'mailing_state_province', name: 'Mailing State'},
            {attribute: 'mailing_state_province_code', name: 'Mailing State Abbreviation'},
            {attribute: 'mailing_zip_postal_code', name: 'Mailing Zip Code'},

            {attribute: 'telephone_number', name: 'Telephone Number', initial: true},

            {attribute: 'status_indicator', name: 'Status'},
            {attribute: 'lob', name: 'Line of Business', initial: true},
            {attribute: 'url_domain', name: 'URL'},
            {attribute: 'latitude', name: 'Latitude', initial: true},
            {attribute: 'longitude', name: 'Longitude', initial: true},

            {attribute: 'primary_naics', name: 'Primary NAICS', initial: true},
            {attribute: 'naics2', name: 'NAICS 2'},
            {attribute: 'naics3', name: 'NAICS 3'},
            {attribute: 'naics4', name: 'NAICS 4'},
            {attribute: 'naics5', name: 'NAICS 5'},
            {attribute: 'naics6', name: 'NAICS 6'},

            {attribute: 'primary_sic', name: 'Primary SIC', initial: true},
            {attribute: 'sic2', name: 'SIC 2'},
            {attribute: 'sic3', name: 'SIC 3'},
            {attribute: 'sic4', name: 'SIC 4'},
            {attribute: 'sic5', name: 'SIC 5'},
            {attribute: 'sic6', name: 'SIC 6'},

            {attribute: 'pub_pvt', name: 'Public or Private'},

            {attribute: 'contact_1_prefix', name: 'Primary Contact Prefix'},
            {attribute: 'contact_1_first_name', name: 'Primary Contact First Name'},
            {attribute: 'contact_1_middle_initi', name: 'Primary Contact Middle Initial'},
            {attribute: 'contact_1_last_name', name: 'Primary Contact Last Name'},
            {attribute: 'contact_1_suffix', name: 'Primary Contact Suffix'},
            {attribute: 'contact_1_full_name', name: 'Primary Contact'},
            {attribute: 'contact_1_title', name: 'Primary Contact Title'},
            {attribute: 'contact_1_mrc_code', name: 'Primary Contact MRC Code'},

            {attribute: 'contact_2_full_name', name: 'Secondary Contact'},
            {attribute: 'contact_2_title', name: 'Secondary Contact Title'},
            {attribute: 'contact_2_mrc_code', name: 'Secondary Contact MRC Code'},

            {attribute: 'contact_3_full_name', name: 'Tertiary Contact'},
            {attribute: 'contact_3_title', name: 'Tertiary Contact Title'},
            {attribute: 'contact_3_mrc_code', name: 'Tertiary Contact MRC Code'},

            {attribute: 'sales_volume', name: 'Sales Volume', initial: true, isSize: true},
            {attribute: 'sales_volume_description', name: 'Sales Volume Description'},
            {attribute: 'total_employees', name: 'Total Employees', initial: true, isSize: true},
            {attribute: 'total_employees_description', name: 'Total Employees Description'},
            {attribute: 'local_employees', name: 'Local Employees', initial: true, isSize: true},
            {attribute: 'local_employees_description', name: 'Local Employees Description'},
            {attribute: 'year_started', name: 'Year Started', initial: true},
            {attribute: 'home_based', name: 'Home-Based Business'},
            {attribute: 'state_incorp', name: 'State of Incorporation'},
            {attribute: 'headquarters_country', name: 'Headquarters Country Name'},
            {attribute: 'msa_code', name: 'MSA Code'},
            {attribute: 'fax_number', name: 'Fax Number'},
            {attribute: 'bemfab_indicator', name: 'BEMFAB Indicator'}
        ],

        create({project, country, censusRelease, name, locationItems, businessSearch}) {
            var columns = this.getColumns(country.getCode(), true),
                data = {
                    type: 'businessSearchTable',
                    attributeFields: Ext.Array.pluck(columns, 'attribute'),
                    buildingBlocksCensusRelease: censusRelease,
                    businessSearch,
                    filterVisibility: 'strikeout',
                    locationItems: Ext.Array.from(locationItems[0]),
                    name
                };

            return new SA.data.BusinessSearchTableView({project, data});
        },

        getColumnName(country, attribute) {
            var cache = this.columnNamesCache || (this.columnNamesCache = {}),
                names = cache[country];

            if (!names) {
                names = cache[country] = {};

                this.getColumns(country).forEach(column => {
                    names[column.attribute] = column.name;
                });
            }

            return names[attribute];
        },

        getColumns(country, initial) {
            return Ext.Array.clean(this.columns.map(column => {
                if (!SA.data.BusinessSearches.isFieldAllowed(country, column.attribute)) {
                    return;
                }

                if (initial && column.initial !== true) {
                    return;
                }

                column = Object.assign({}, column);

                if (country === 'CAN') {
                    column.name = column.name.replace('State', 'Province').replace('Zip', 'Postal');
                }

                return column;
            }));
        },

        isSizeAttribute(attribute) {
            return this.columns.find(column => column.attribute === attribute).isSize ?? false;
        },

        supportsAttribute() {
            return false;
        }
    },

    constructor() {
        this.callParent(arguments);

        if (!this.getSort()) {
            this.setSort('legal_name', 'asc');
        }
    },

    addAttribute(attribute) {
        this.project.addAttribute(attribute);

        this.fireEvent('invoke:addAttribute');
    },

    createController() {
        return new SA.BusinessTableController(this);
    },

    createDataMap() {
        return new SA.data.BusinessSearchTableView.DataMap({
            businessSearch: SA.data.BusinessSearches.toQuery(this.getBusinessSearch()),
            country: this.getCountry(),
            location: this.getQueryLocation(),
            sort: this.getSort(),

            listeners: {
                'change:loadstate': (loadingState) => {
                    this.fireEvent('change:loadstate', loadingState);
                }
            }
        });
    },

    getAttributes() {
        return this.data.attributeFields;
    },

    getBusinessSearch() {
        return this.data.businessSearch;
    },

    getBusinessSearches() {
        var search = this.getBusinessSearch();

        return search ? [search] : [];
    },

    getExportQuery() {
        var getColumnName = attribute => SA.data.BusinessSearchTableView.getColumnName(this.getCountry(), attribute);

        return this.getDataMap().createQueryConfig(this.getAttributes().map(id => ['with', id, getColumnName(id)]));
    },

    getReportData(cfg) {
        cfg = cfg || {};

        var map = this.getDataMap();

        map.ensure({
            attributes: this.getAttributes(),
            fn: cfg.fn,
            scope: cfg.scope
        });

        return map.getData();
    },

    getSort() {
        return this.data.sort;
    },

    getSortAttribute() {
        return this.getSort()[1];
    },

    getSortDirection() {
        return this.getSort()[0];
    },

    getTotal() {
        return this.getDataMap().getData().total;
    },

    isSavable() {
        return this.getLocation() && this.getBusinessSearch();
    },

    setAttributesImpl(attributes) {
        this.data.attributeFields = attributes;
    },

    setBusinessSearch(search) {
        if (search !== this.getBusinessSearch()) {
            this.clearDataMap();
            this.setWithEvent('businessSearch', search);
        }
    },

    setLocationImpl(location) {
        this.mixins.locations.setLocationImpl.call(this, location);

        this.clearDataMap();

        if (location) {
            this.project.addLocation(location);
        }
    },

    setSort(attribute, direction) {
        var sort = SA.model.Sort.from(attribute, direction);

        if (!sort.equal(this.data.sort)) {
            this.set('sort', sort.toArray());
            this.clearDataMap();
            this.fireEvent('change:sort', this);
        }
    }
});

Ext.define('SA.data.BusinessSearchTableView.DataMap', {
    mixins: {
        observable: 'Ext.util.Observable'
    },

    constructor(cfg) {
        Object.assign(this, cfg);

        this.mixins.observable.constructor.call(this, cfg);

        this.data = {locationSeries: []};
        this.callbacks = new SA.data.CallbackSet();
    },

    createQueryConfig(attributes) {
        var location = this.location,
            searchQuery = this.businessSearch,
            sort = this.sort,
            where = ['and', ['=', 'locationClass', 'gri\\data\\location\\BusinessPointLocation'], searchQuery],
            sorting = [sort];

        if (location.type === 'radius') {
            where.push(['radius', 'duns', location.radius, location.locationSeries[0]]);
        }
        else {
            where.push(['within'].concat(location.locationSeries));
        }

        if (sort[1] !== 'legal_name') {
            sorting.push(['asc', 'legal_name']);
        }

        return {
            country: this.country,
            fields: attributes,
            limit: 10000,
            sort: sorting,
            type: 'businesses',
            where
        };
    },

    ensure(cfg) {
        var map = this.data,
            attributes = cfg.attributes,
            callbacks = this.callbacks,
            missingAttributes = [];

        attributes.forEach(attribute => {
            if (!map[attribute]) {
                map[attribute] = [];
            }
        });

        if (map.total === 0) {
            return;
        }

        if (this.activeQuery) {
            callbacks.add(cfg.fn, cfg.scope);
            return;
        }

        for (let attribute in map) {
            if (attribute !== 'total' && !map[attribute].length) {
                missingAttributes.push(attribute);
            }
        }

        if (missingAttributes.length) {
            callbacks.add(cfg.fn, cfg.scope);

            this.run(missingAttributes);
        }
    },

    getData() {
        return this.data;
    },

    removeAttribute(attribute) {
        delete this.data[attribute];
    },

    run(attributes) {
        var me = this,
            query;

        if (!this.businessSearch || !this.location) {
            return;
        }

        this.fireEvent('change:loadstate', { isLoading: true });

        query = this.createQueryConfig(attributes);

        this.activeQuery = query = SA.data.Query.from(query);

        query.addFailure(clearActiveQuery);

        query.addSuccess(rows => {
            var map = this.data;

            map.total = rows.length;

            clearActiveQuery();

            rows.forEach((row, index) => {
                for (let attribute in row) {
                    let list = map[attribute];

                    if (list) {
                        list[index] = row[attribute];
                    }
                }
            });

            this.callbacks.run();
        });

        query.run();

        function clearActiveQuery() {
            me.activeQuery = null;

            me.fireEvent('change:loadstate', { isLoading: false });
        }
    }
});
